// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @author John Molakvoæ <skjnldsv@protonmail.com>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
.material-design-icon[data-v-7358bc59] {
  display: flex;
  align-self: center;
  justify-self: center;
  align-items: center;
  justify-content: center;
}
.header-menu[data-v-7358bc59] {
  position: relative;
  width: var(--header-height);
  height: var(--header-height);
}
.header-menu__trigger[data-v-7358bc59] {
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--header-height);
  height: var(--header-height);
  margin: 0;
  padding: 0;
  cursor: pointer;
  opacity: .85;
  background-color: transparent;
  border: none;
  filter: none !important;
  color: var(--color-primary-text) !important;
}
.header-menu--opened .header-menu__trigger[data-v-7358bc59],
.header-menu__trigger[data-v-7358bc59]:hover,
.header-menu__trigger[data-v-7358bc59]:focus,
.header-menu__trigger[data-v-7358bc59]:active {
  opacity: 1;
}
.header-menu__trigger[data-v-7358bc59]:focus-visible {
  outline: none;
}
.header-menu__wrapper[data-v-7358bc59] {
  position: fixed;
  z-index: 2000;
  top: 50px;
  inset-inline-end: 0;
  box-sizing: border-box;
  margin: 0 8px;
  padding: 8px;
  border-radius: 0 0 var(--border-radius) var(--border-radius);
  border-radius: var(--border-radius-large);
  background-color: var(--color-main-background);
  filter: drop-shadow(0 1px 5px var(--color-box-shadow));
}
.header-menu__carret[data-v-7358bc59] {
  position: absolute;
  z-index: 2001;
  bottom: 0;
  inset-inline-start: calc(50% - 10px);
  width: 0;
  height: 0;
  content: " ";
  pointer-events: none;
  border: 10px solid transparent;
  border-bottom-color: var(--color-main-background);
}
.header-menu__content[data-v-7358bc59] {
  overflow: auto;
  width: 350px;
  max-width: calc(100vw - 16px);
  min-height: 66px;
  max-height: calc(100vh - 100px);
}
.header-menu__content[data-v-7358bc59] .empty-content {
  margin: 12vh 10px;
}
@media only screen and (max-width: 512px) {
  .header-menu[data-v-7358bc59],
  .header-menu__trigger[data-v-7358bc59] {
    width: 44px;
  }
}
`, "",{"version":3,"sources":["webpack://./node_modules/@nextcloud/vue/dist/assets/index-aacb7cf8.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;;;;;;;;;;;;;;;;EAoBE;AACF;EACE,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,SAAS;EACT,UAAU;EACV,eAAe;EACf,YAAY;EACZ,6BAA6B;EAC7B,YAAY;EACZ,uBAAuB;EACvB,2CAA2C;AAC7C;AACA;;;;EAIE,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,YAAY;EACZ,4DAA4D;EAC5D,yCAAyC;EACzC,8CAA8C;EAC9C,sDAAsD;AACxD;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,oCAAoC;EACpC,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,oBAAoB;EACpB,8BAA8B;EAC9B,iDAAiD;AACnD;AACA;EACE,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,+BAA+B;AACjC;AACA;EACE,iBAAiB;AACnB;AACA;EACE;;IAEE,WAAW;EACb;AACF","sourcesContent":["@charset \"UTF-8\";\n/**\n * @copyright Copyright (c) 2019 John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @author John Molakvoæ <skjnldsv@protonmail.com>\n *\n * @license GNU AGPL version 3 or any later version\n *\n * This program is free software: you can redistribute it and/or modify\n * it under the terms of the GNU Affero General Public License as\n * published by the Free Software Foundation, either version 3 of the\n * License, or (at your option) any later version.\n *\n * This program is distributed in the hope that it will be useful,\n * but WITHOUT ANY WARRANTY; without even the implied warranty of\n * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the\n * GNU Affero General Public License for more details.\n *\n * You should have received a copy of the GNU Affero General Public License\n * along with this program. If not, see <http://www.gnu.org/licenses/>.\n *\n */\n.material-design-icon[data-v-7358bc59] {\n  display: flex;\n  align-self: center;\n  justify-self: center;\n  align-items: center;\n  justify-content: center;\n}\n.header-menu[data-v-7358bc59] {\n  position: relative;\n  width: var(--header-height);\n  height: var(--header-height);\n}\n.header-menu__trigger[data-v-7358bc59] {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: var(--header-height);\n  height: var(--header-height);\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n  opacity: .85;\n  background-color: transparent;\n  border: none;\n  filter: none !important;\n  color: var(--color-primary-text) !important;\n}\n.header-menu--opened .header-menu__trigger[data-v-7358bc59],\n.header-menu__trigger[data-v-7358bc59]:hover,\n.header-menu__trigger[data-v-7358bc59]:focus,\n.header-menu__trigger[data-v-7358bc59]:active {\n  opacity: 1;\n}\n.header-menu__trigger[data-v-7358bc59]:focus-visible {\n  outline: none;\n}\n.header-menu__wrapper[data-v-7358bc59] {\n  position: fixed;\n  z-index: 2000;\n  top: 50px;\n  inset-inline-end: 0;\n  box-sizing: border-box;\n  margin: 0 8px;\n  padding: 8px;\n  border-radius: 0 0 var(--border-radius) var(--border-radius);\n  border-radius: var(--border-radius-large);\n  background-color: var(--color-main-background);\n  filter: drop-shadow(0 1px 5px var(--color-box-shadow));\n}\n.header-menu__carret[data-v-7358bc59] {\n  position: absolute;\n  z-index: 2001;\n  bottom: 0;\n  inset-inline-start: calc(50% - 10px);\n  width: 0;\n  height: 0;\n  content: \" \";\n  pointer-events: none;\n  border: 10px solid transparent;\n  border-bottom-color: var(--color-main-background);\n}\n.header-menu__content[data-v-7358bc59] {\n  overflow: auto;\n  width: 350px;\n  max-width: calc(100vw - 16px);\n  min-height: 66px;\n  max-height: calc(100vh - 100px);\n}\n.header-menu__content[data-v-7358bc59] .empty-content {\n  margin: 12vh 10px;\n}\n@media only screen and (max-width: 512px) {\n  .header-menu[data-v-7358bc59],\n  .header-menu__trigger[data-v-7358bc59] {\n    width: 44px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
